import { apiGet } from '../../MainModule/common/apiTools';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { IEpguNotificationPage } from '../interfaces/IEpguNotificationPage';

export async function fetchEpguNotification(
  knmId: number | undefined,
  decisionId: string | undefined,
  organizationGuid: string,
  page: number,
  pageSize: number,
  type: string,
): Promise<IEpguNotificationPage> {
  const queryParams = new URLSearchParams();
  let url: string;

  queryParams.append('page', page.toString());
  queryParams.append('size', pageSize.toString());
  queryParams.append('passportType', type);

  if (knmId !== undefined) {
    url = `${getServiceBaseURL(
      APIServiceEnum.KNM_SERVICE,
    )}/knm/${knmId}/subject/${organizationGuid}/epgu-event-notifications`;
  } else if (decisionId !== undefined) {
    url = `${getServiceBaseURL(
      APIServiceEnum.KNM_SERVICE,
    )}/decision-passport/${decisionId}/subject/${organizationGuid}/epgu-event-notifications`;
  } else {
    return Promise.resolve({
      list: [],
      totalCount: 0,
      page: 0,
      pageCount: 0,
      order: null,
    } as IEpguNotificationPage);
  }

  return apiGet<IEpguNotificationPage>(`${url}?${queryParams.toString()}`);
}
